// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_int32 from "../../../../node_modules/rescript/lib/es6/caml_int32.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Previous$Showside from "./Previous.bs.js";
import * as EdgeSwipeDetector$Showside from "./EdgeSwipeDetector.bs.js";
function useSequence(onPhaseChangeOpt, allowPhaseChangeOpt, timedPhases) {
  var onPhaseChange = onPhaseChangeOpt !== undefined ? onPhaseChangeOpt : function (param) {};
  var allowPhaseChange = allowPhaseChangeOpt !== undefined ? allowPhaseChangeOpt : function (param) {
    return true;
  };
  var didEdgeSwipe = EdgeSwipeDetector$Showside.useEdgeSwipeDetector(undefined);
  var timedPhases$1 = Curry._1(didEdgeSwipe, undefined) ? Belt_Array.map(timedPhases, function (param) {
    return [param[0], 0];
  }) : timedPhases;
  var phases = Belt_Array.map(timedPhases$1, function (param) {
    return param[0];
  });
  var durations = Belt_Array.map(timedPhases$1, function (param) {
    return param[1];
  });
  var initialPhase = phases[0];
  var match = React.useState(function () {
    return initialPhase;
  });
  var setPhase = match[1];
  var phase = match[0];
  var total = phases.length;
  var index = Belt_Option.getWithDefault(Belt_Array.getIndexBy(phases, function (p) {
    return Caml_obj.equal(p, phase);
  }), 0);
  var phase$1 = phases[index];
  var duration = durations[index];
  var timeout = React.useRef(undefined);
  var nextPhase = Belt_Array.get(phases, index + 1 | 0);
  var next = Belt_Option.map(nextPhase, function (nextPhase) {
    return {
      phase: nextPhase,
      previousPhase: phase$1,
      currentSequence: phases,
      index: index,
      total: total
    };
  });
  var phaseChangeAllowed = Belt_Option.getWithDefault(Belt_Option.map(next, allowPhaseChange), true);
  var nextRef = React.useRef(next);
  nextRef.current = next;
  React.useLayoutEffect(function () {
    if (total !== 1 || duration !== 0) {} else {
      Curry._1(onPhaseChange, {
        phase: phase$1,
        previousPhase: phase$1,
        currentSequence: phases,
        index: index,
        total: total
      });
    }
  }, [phase$1, duration, total]);
  React.useLayoutEffect(function () {
    if (phaseChangeAllowed) {
      Belt_Option.map(timeout.current, function (prim) {
        clearTimeout(prim);
      });
      timeout.current = Caml_option.some(setTimeout(function (param) {
        var next = nextRef.current;
        if (next !== undefined) {
          Curry._1(setPhase, function (param) {
            return next.phase;
          });
          return Curry._1(onPhaseChange, next);
        }
      }, duration));
    }
  }, [nextPhase, phaseChangeAllowed]);
  return [phase$1, duration];
}
function useStagger(length, duration, isOpen) {
  var wasOpen = Previous$Showside.usePreviousDistinct(isOpen);
  var durationPerItem = Caml_int32.div(duration, length);
  var phases = wasOpen ? isOpen ? [[length - 1 | 0, 0]] : Belt_Array.makeBy(length, function (i) {
    return [length - i | 0, durationPerItem];
  }) : isOpen ? Belt_Array.makeBy(length, function (i) {
    return [i, durationPerItem];
  }) : [[0, 0]];
  return useSequence(undefined, undefined, phases)[0];
}
export { useSequence, useStagger };
/* react Not a pure module */